<template>
  <question-card class="property-type-step" hide-button>
    <template #title>
      {{ UIComponentData.Header.Translations[questionnaireLead.Language] }}
    </template>
    <div class="propertyStep">
      <answer-icon-block>
        <answer-icon
          @click="answer(answers.singleFamily)"
          image="single_family.svg"
          :checked="questionnaireLead.PropertyType === answers.singleFamily"
        >
          {{ UIComponentData.Choice1.Translations[questionnaireLead.Language] }}
        </answer-icon>
        <answer-icon
          @click="answer(answers.townhome)"
          image="townhome.svg"
          :checked="questionnaireLead.PropertyType === answers.townhome"
        >
          {{ UIComponentData.Choice2.Translations[questionnaireLead.Language] }}
        </answer-icon>
        <answer-icon
          @click="answer(answers.condo)"
          image="condo.svg"
          :checked="questionnaireLead.PropertyType === answers.condo"
        >
          {{ UIComponentData.Choice3.Translations[questionnaireLead.Language] }}
        </answer-icon>
        <answer-icon
          @click="answer(answers.multiFamily)"
          image="multi_family.svg"
          note="2-4 units"
          :checked="questionnaireLead.PropertyType === answers.multiFamily"
        >
          {{ UIComponentData.Choice4.Translations[questionnaireLead.Language] }}
        </answer-icon>
        <answer-icon
          @click="answer(answers.manufactured)"
          image="manufactured.svg"
          :checked="questionnaireLead.PropertyType === answers.manufactured"
        >
          {{ UIComponentData.Choice5.Translations[questionnaireLead.Language] }}
        </answer-icon>
      </answer-icon-block>
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ANSWERS } from "@/utils/constants/common";
import QuestionCard from "@/components/QuestionCard.vue";
import AnswerIcon from "@/components/AnswerIcon.vue";
import AnswerIconBlock from "@/components/AnswerIconBlock.vue";

export default {
  name: "property-type-step",
  components: {
    QuestionCard,
    AnswerIcon,
    AnswerIconBlock,
  },
  data: () => ({
    answers: ANSWERS.propertyTypes,
  }),
  props: {
    UIComponentData: {
      type: Object,
      required: true,
    },
    UIId: Number
  },
  computed: {
    ...mapGetters(["questionnaireLead"]),
    purposeAction() {
      return this.questionnaireLead.LoanPurpose === "Purchase"
        ? "purchasing"
        : "refinancing";
    },
  },
  methods: {
    ...mapActions(["mutateLead"]),
    async answer(value) {
      this.questionnaireLead.PropertyType = value;
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixins";
@import "~@/styles/variables";

.property-type-step {
  .answer-icon-block{
    max-width: 590px;
    margin: 0 auto;
  }

  .answer-icon {
    flex: 1 1 150px;
    padding: 30px 0;
      @media (min-width: 530px) {
        height: 170px;
      }
  

    &:not(:last-child) {
      .answer-icon__image-wrapper {
        position: relative;

        &::after {
          content: none;
        }
      }
    }
    &::after{
      display: none;
    }

    &:nth-child(1) {
      padding-top: 0;
      @media (max-width: 380px) {
        border-bottom: $quest-icon-splitter-border;
      }
    }

    &:nth-child(2) {
      padding-top: 0;
      border-left: $quest-icon-splitter-border;
      @media (max-width: 380px) {
        border-left: none;
      }

    }

    &:nth-child(3) {
      border-top: $quest-icon-splitter-border;
      @media (min-width: 530px) {
        border-top: none;
        border-left: $quest-icon-splitter-border;
      }
    }

    &:nth-child(4) {
      border: {
        left: $quest-icon-splitter-border;
        top: $quest-icon-splitter-border;
      }
      @media (max-width: 380px) {
        border-left: none;
      }
      @media (min-width: 530px) {
        border-left: none;
        border-right: $quest-icon-splitter-border;

      }
    }

    &:nth-child(5) {
      padding-bottom: 0;
      border-top: $quest-icon-splitter-border;
    }
  }

  .answer-icon {
    &:nth-child(-n + 5) {
      padding: 20px 0;
    }
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}
</style>
<style lang="scss">
.propertyStep{
  .answer-icon__image-wrapper {
      min-height: 84px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
  .answer-icon__answer {
      flex-grow: 1;
    }
}
</style>